// extracted by mini-css-extract-plugin
export var content = "_s8-1";
export var wrapper = "_s8-0";